// src/lib/inbox-escalation-labels.js — Chantier 12 LOT 1 (escalade IN-APP).
//
// Source UNIQUE des libellés FR des codes de raison d'escalade du copilote IA,
// importée à la fois par InboxComposer (banner « à traiter ») et InboxPanel
// (drapeau 🚩 + tooltip). Pas de copie : un seul map, un seul vocabulaire.
//
// Les clés sont l'enum `reason_code` du backend (cf. lib/inbox-ai-escalation-reasons.js).
// Un code inconnu retombe sur un libellé générique (jamais d'écran vide).

export const ESCALATION_REASON_LABELS_FR = Object.freeze({
  keyword: "sujet sensible détecté",
  classifier: "message à traiter par un humain",
  classifier_failed: "analyse IA indisponible",
  reservation_inactive: "réservation annulée / no-show",
  dispo_inconnue: "disponibilité inconnue",
  low_confidence: "doute de l'IA",
  info_absente: "info absente du livret",
});

/**
 * reasonLabelFR(code) — libellé FR d'un reason_code d'escalade.
 * Repli générique « à traiter par un humain » si le code est inconnu/null.
 * @param {string|null|undefined} code
 * @returns {string}
 */
export function reasonLabelFR(code) {
  return ESCALATION_REASON_LABELS_FR[code] || "à traiter par un humain";
}
